import React from "react";
import { useTranslation } from "i18n";

export interface IPaginationResultStatsProps {
  page: number;
  itemsPerPage: number;
  itemsTotal: number;
  textTemplate: string;
  "data-testid"?: string;
}

const PaginationResultStats = (props: IPaginationResultStatsProps) => {
  const { t } = useTranslation();
  const { page = 1, itemsPerPage, itemsTotal } = props;

  const start = itemsTotal ? itemsPerPage * (page - 1) + 1 : 0;
  const end = Math.min(start + itemsPerPage - 1, itemsTotal);

  const totalText = itemsTotal.toLocaleString();
  const rangeText = `${start.toLocaleString()}-${end.toLocaleString()}`;

  return (
    <div
      className="c-pagination-result-stats text-[14px] leading-[18px] text-grey-stone-4"
      data-testid={props["data-testid"]}
    >
      <span className="font-semibold text-black">{totalText}</span>
      <span className="whitespace-pre font-normal text-grey-stone-4">
        {t("common:pagination.resultStats.separator")}
      </span>
      <span className="font-semibold text-black">{rangeText}</span>
    </div>
  );
};

export default React.memo(PaginationResultStats);
